<template>

  <div :class="`card ${ifCurAnswer ? 'card_modi card_true' : ifCurAnswer !== null ? 'card_modi card_false' : '' }`">

    <transition name="fade">

      <div class="illustration"
           v-show="!clip"
           :style="`background-image: url(./illustrations/${question}.png)`"
      ></div>

    </transition>

    <div class="true-false-container">

      <div class="true-false true">верю</div>
      <div class="true-false false">не верю</div>

    </div>

    <transition name="fade">

      <p v-show="ifCurAnswer !== null" class="state">{{ifCurAnswer ? 'верю' : 'не верю'}}</p>

    </transition>

    <transition name="fade-clip">

      <div v-show="ifCurAnswer !== null" class="clip-container">

        <video
          webkit-playsinline
          :muted='muted'
          playsinline
          id="video"
          :src="`./clips/${question}.mp4`"
          class="clip"
        ></video>

        <a :href="url" @click='() => muted = true' target="_blank" class="link-container"></a>

      </div>

    </transition>

    <!-- <div class="interface" v-show="clip"></div> -->

  </div>

</template>

<script>
export default {
  name: 'App',
  data(){

    return {
      muted: false,
    }

  },
  watch: {
    question() {
      this.muted = false
    }
  },
  props: ['answer', 'ifCurAnswer', 'question', "url", "clip"],
}
</script>

<style scoped lang="sass">

  .link-container
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    cursor: pointer

  .interface
    width: 13.5%
    height: 40%
    position: absolute
    right: 6px
    bottom: 7%
    pointer-events: none
    background-image: url(../assets/img/interface.svg)

  .card
    width: 355px
    height: 305px
    padding: 15px
    position: relative
    background-color: white
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    transition: background-color .3s linear, width .3s ease-out, height .3s ease-out

    &_modi
      width: 214px
      height: 364px
      background-color: transparent
      transition: border .3s linear .3s, background-color .3s linear .3s, width .3s ease-out .3s, height .3s ease-out .3s

      .button-modern, .illustration, .true-false
        transition: opacity .25s linear
        opacity: 0

      .clip-container
        width: calc(100% - 8px)
        height: calc(100% - 8px)

      .clip, .state
        opacity: 1
        transition: opacity .25s linear

    &_true
      border: 2px solid #B0F80C

      .state
        color: #B0F80C

    &_false
      border: 2px solid #D357FF

      .state
        color: #D357FF

  .illustration
    width: 260px
    height: 221px
    top: -30px
    transition: background-image .3s linear

  .true-false
    font-family: "VK Sans Display"
    color: black
    font-size: .95em
    font-weight: 400
    width: 114px
    text-align: center
    transition: opacity .25s linear .3s

    &-container
      margin-top: 10px
      padding: 0 25px
      position: absolute
      bottom: 30px
      width: 100%
      display: flex
      justify-content: space-between

  .clip
    opacity: 0
    width: 105%
    height: auto
    margin-left: -2.5%
    position: initial

    &-container
      width: calc(100% - 8px)
      height: 100%
      overflow: hidden
      position: absolute
      margin: 0 auto
      top: 4px
      cursor: pointer
      border-radius: 8px

  .state
    font-family: "VK Sans Display"
    opacity: 0
    position: absolute
    font-size: 1.8em
    font-weight: 300
    bottom: -35px

@media (max-width: 420px)
  .clip-container
    height: calc(100% - 1.8vw)
    width: calc(100% - 1.8vw)
    border-radius: 2vw

  .true-false
    width: 30vw

    &-container
      margin-top: 5vw
      padding: 0 5.5vw

  .card
    width: 80vw
    height: 73.75vw
    padding: 5vw
    border-radius: 3.75vw
    border-width: 0.5vw

    &_modi
      width: 53vw
      height: 90vw
      padding: .9vw

  .illustration
    width: 56vw
    height: 50vw
</style>
